import { ResultPage } from '@/ui'

export default ResultPage
